// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"19":"7586e092","51":"74261db8","58":"c2d0f7d4","373":"1cf5dde7","493":"decf111f","503":"cc7eb0a8","561":"a0c3de07","681":"a3f2a6d3","980":"b04bbd13"}[chunkId] + ".css";
};